import { memo } from 'react';
import styled from '@emotion/styled';
import { CallRole_Utils, Transcribe } from '@trinity/chat';
import { roleIsModeratorLike } from '@trinity/chat-components/utils';

type SpeakerProps = {
  className?: string;
  displayName: string;
  speaker: Transcribe.Speaker;
};

export const Speaker = memo((props: SpeakerProps) => {
  const hasModeratorRole = roleIsModeratorLike(props.speaker?.role);
  const isModerator = hasModeratorRole && props.speaker?.name != 'Moderator';

  return (
    <StyledRoot className={props.className}>
      {props.displayName}
      {isModerator && (
        <SpeakerRole>
          ({CallRole_Utils.getName(props.speaker.role)})
        </SpeakerRole>
      )}
    </StyledRoot>
  );
});

const StyledRoot = styled.div(({ theme }) => ({
  color: theme.palette.wl?.enabled ? theme.palette.primary.main : '#28AAE1',
  fontFamily: theme.fonts.bold,
  display: 'flex',
  alignItems: 'center',
}));

const SpeakerRole = styled.span(({ theme }) => ({
  fontSize: 12,
  marginLeft: 4,
}));